import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface GrilleProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function Grille(props: GrilleProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Grille"
      width={43}
      height={298}
      viewBox="0 0 43 298"
      position={{top: 102, left: 0}}
    >
      <path
        d="M11 163V149V135C10.9999 128.189 16 117 16 117C24.2294 101.97 18.2683 46.1164 31 17.0002C32.9319 12.5821 40 2 40 2C15 8 12 28 12 28C4.44151 57.9723 1 87.1691 1 107V149V191C1 210.831 4.44151 240.028 12 270C12 270 15 290 40 296C40 296 32.9319 285.418 31 281C18.2683 251.884 24.2294 196.03 16 181C16 181 10.9999 169.811 11 163Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M11 163V149V135C10.9999 128.189 16 117 16 117C24.2294 101.97 18.2683 46.1164 31 17.0002C32.9319 12.5821 40 2 40 2C15 8 12 28 12 28C4.44151 57.9723 1 87.1691 1 107V149V191C1 210.831 4.44151 240.028 12 270C12 270 15 290 40 296C40 296 32.9319 285.418 31 281C18.2683 251.884 24.2294 196.03 16 181C16 181 10.9999 169.811 11 163Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
